<div class="container-fluid py-3">
  <div class="mb-3">
    <h3 class="mb-1">{{ 'i18n.domain.analytics.running-totals.title' | translate }}</h3>
    <p class="text-body-secondary mb-0">{{ 'i18n.domain.analytics.running-totals.subtitle' | translate }}</p>
  </div>

  <div class="row align-items-center mb-3">
    <div class="col-auto">
      <label class="form-label mb-0" for="running-totals-vehicle-id">{{ 'i18n.domain.analytics.running-totals.vehicle-id' | translate }}</label>
    </div>
    <div class="col-auto">
      <input id="running-totals-vehicle-id" type="number" class="form-control" min="1" [(ngModel)]="vehicleId" />
    </div>
    <div class="col-auto">
      <button class="btn btn-primary" type="button" [disabled]="!vehicleId() || isLoading()" (click)="onLoad()">
        {{ 'i18n.domain.analytics.running-totals.load' | translate }}
      </button>
    </div>
  </div>

  @if (groups().length === 0) {
    <div class="card">
      <div class="card-body">
        <p class="text-body-secondary mb-0">{{ 'i18n.domain.analytics.running-totals.empty' | translate }}</p>
      </div>
    </div>
  } @else {
    @for (group of groups(); track group.moduleName) {
      <div class="card module-card mb-3">
        <div class="card-header">
          {{ group.label.key | translate:group.label.params }}
        </div>
        <div class="card-body">
          <div class="row g-3">
            @for (stat of group.stats; track stat.statisticName) {
              <div class="col-6 col-md-4">
                <div class="stat-tile h-100">
                  @if (stat.definition) {
                    <div class="stat-label text-body-secondary small">{{ stat.definition.labelKey | translate }}</div>
                    <div class="stat-value">{{ formatNumber(stat.value, stat.definition.decimals, stat.definition.unit) }}</div>
                    @if (stat.definition.extraKey && stat.extraValue) {
                      <span class="badge text-bg-secondary stat-extra">
                        {{ stat.definition.extraLabelKey | translate }}: {{ stat.extraValue }}
                      </span>
                    }
                    @if (stat.definition.gauge) {
                      <div class="progress mt-2" role="progressbar" [attr.aria-valuenow]="gaugePercent(stat.value, stat.definition.gauge.referenceMax)" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar bg-primary" [style.width.%]="gaugePercent(stat.value, stat.definition.gauge.referenceMax)"></div>
                      </div>
                    }
                  } @else {
                    <div class="stat-label text-body-secondary small">
                      {{ 'i18n.domain.analytics.running-totals.stats.unknown' | translate:{ name: humanizeStatisticName(stat.statisticName) } }}
                    </div>
                    <div class="stat-value stat-value-raw">
                      @for (entry of stat.rawEntries; track entry[0]) {
                        <div>{{ entry[0] }}: {{ entry[1] }}</div>
                      }
                    </div>
                  }
                  <div class="stat-updated text-body-secondary small mt-2">
                    {{ 'i18n.domain.analytics.running-totals.updated' | translate:{ date: formatUpdated(stat.updatedUtc) } }}
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  }
</div>
